export default "__VITE_ASSET__BoM6a3YT__"